import { IonContent, IonPage } from "@ionic/react"
import { ParameterizableControl } from "../canvas-ui/ParameterializableControl"
import VisibilityOutlined from "@mui/icons-material/VisibilityOutlined"

export function SandboxPage() {
  return (
    <IonPage>
      <IonContent>
        <h1>Sandbox Page</h1>

        <div style={{ padding: 15 }}>
          <ParameterizableControl
            type="color"
            title="Color Control"
            icon={<VisibilityOutlined fontSize="small" />}
            value="red"
            bound={true}
            onChange={() => {}}
          >
            Color
          </ParameterizableControl>
        </div>
      </IonContent>
    </IonPage>
  )
}
